export enum EVENTS {
  CUSTOMER_UPDATED = 'customer:updated',
  INVOICE_CREATED = 'invoice:created',
  INVOICE_UPDATED = 'invoice:updated',
  INVOICE_REMOVED = 'invoice:removed'
}